import { useIntl, FormattedMessage } from 'react-intl';

import './index.scss';
import './PaymentError.scss';

const PaymentError = ({ errorMessage }) => {
  const intl = useIntl();

  const renderPrimaryMessage = () => {
    if (errorMessage.includes('security code is incorrect.')) {
      return (
        <FormattedMessage
          id="YOUR_CARD_SECURITY_CODE_IS_INCORRECT"
          defaultMessage="Your credit card security code is incorrect."
        />
      );
    }
    if (errorMessage.includes('Try again in a little bit.')) {
      return (
        <FormattedMessage
          id="PLEASE_TRY_AGAIN"
          defaultMessage="Please try again"
        />
      );
    }

    const regex = /[.,\s]/g;
    const messageAsKey = errorMessage
      .toUpperCase()
      .split(' ')
      .join('_')
      .replace(regex, '');

    const translatedMessage = intl.messages?.[messageAsKey];

    if (!translatedMessage) {
      // We found no key, fallback to the original message
      return errorMessage;
    }

    return translatedMessage;
  };

  return (
    <div className="PaymentError-Container">
      <div className="PaymentError-Message">
        <h1 className="header">
          <FormattedMessage id="PAYMENT_ERROR" defaultMessage="Payment Error" />
        </h1>
        <div className="errorBox">
          <div className="iconBox">
            <i
              className="fa fa-exclamation-triangle"
              aria-hidden="true"
              role="img"
            />
          </div>
          <div className="message">
            <span>{renderPrimaryMessage()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentError;
